import Commander from "../Commander";
import {CONFIG_PARAMS} from "../../framework/src/system/SystemConfig";
import * as PIXI from "pixi.js-legacy";
import {pixiSetTimeout} from "../../framework/src/engine/pixi/pixiTimeout";


class SymbolAnimations {
    constructor(commander) {
        this.commander = commander;
        this.layer = {
            reels: this.commander.layers.reels,
            beam: this.commander.layers.win.children[0],
            wild: this.commander.layers.win.children[1],
            anim: this.commander.layers.win.children[2],
            particles: this.commander.layers.win.children[3],
            numbers: this.commander.layers.win.children[4]
        };

        this.winSymbols =  [
            [undefined,undefined,undefined],
            [undefined,undefined,undefined],
            [undefined,undefined,undefined],
            [undefined,undefined,undefined],
            [undefined,undefined,undefined]
        ];
        this.resSymbols = [];


    }

    init() {
        let definitions = this.getSymbolDefinitions();
        this.brightness = {b: 1};

        this.filter = new PIXI.filters.ColorMatrixFilter();
        this.layer.reels.filters = [this.filter];
        this.duration = .065;
    }

    run(symbol, callback = () => {}) {

        return new Promise(res => {
            symbol.play(this.layer.anim);
            pixiSetTimeout(this.duration, res);
        }).then(() => {
            callback();
        })
    }

    getSymbolDefinitions() {
        return this.commander.config.get(CONFIG_PARAMS.SYMBOL_DEFINITION);
    }

    getSymbolId(name) {
        for(let def of this.getSymbolDefinitions()) {
            if (name === def.name)
                return def.index;
        }
        return false;
    }

    reelsBrightness(brightness) {
        this.filter.brightness(brightness, false);
    }

    delay(count) {
        return new Promise(resolve => setTimeout(resolve, this.duration*count*1000));
    }

    darkenReels() {
        Commander.removeTween(this.brightness);
        createjs.Tween.get(this.brightness)
            .to({b: 0.5}, 200, createjs.Ease.linear)
            .call(() => {Commander.removeTween(this.brightness)})
            .addEventListener("change", () => {
                this.reelsBrightness(this.brightness.b);
            });
    }

    lightenReels() {
        Commander.removeTween(this.brightness);
        createjs.Tween.get(this.brightness)
            .to({b: 1}, 200, createjs.Ease.linear)
            .call(() => {
                Commander.removeTween(this.brightness);
                //this.commander.WinController.removeWinSymbols();
            })
            .addEventListener("change", () => {
                this.reelsBrightness(this.brightness.b);
            });
    }

    drawWinSymbols(result, respin = 0, showWild = false) {
        this.resSymbols = this.commander.slots.getResultSymbols();
        this.setWinSymbols(result, respin);
        for (let i = 0; i < 5; i++) {
            for (let j = 0; j < 3; j++) {
                if (this.winSymbols[i][j] === true) {
                    this.layer.anim.addChild(this.resSymbols[i * 3 + j]);
                }
            }
        }
    }

    removeWinSymbols() {
        this.winSymbols = [
            [false,false,false],
            [false,false,false],
            [false,false,false],
            [false,false,false],
            [false,false,false]
        ];
    }

    setWinSymbols(result, respin) {
        let counter = 0;
        for(let lineWin of result.lineWins) {
            if (lineWin.type === "respin" || lineWin.type === "spread") {
                counter++;
                continue;
            }
            if (counter > respin)
                return;
            if (counter < respin)
                continue;
            if (counter === respin) {
                for(let pos of lineWin.position) {
                    this.winSymbols[pos[0]][pos[1]] = true;
                }
            }
        }
    }

    /**
     * Set the attribute visible to false of symbol given by reelX, reelY coordinates.
     * @param position
     */
    hideWildSymbol(position) {
        for(let sprite of this.layer.wild.children) {
            if (sprite.reelX === position.x && sprite.reelY === position.y)
                sprite.visible = false;
        }
    }

    /**
     * Iterate through layerWild children, delete all sprites that have the same position (spiral and wild text).
     * Create new symbol Wild sprite instead and set its wild parameter to true.
     * If a sprite has the parameter wild set to true, only change the visibility to true and alpha to 1.
     * @param symbol
     */
    showWildSymbol(symbol) {
        let isWild = false;
        for(let sprite of this.layer.wild.children) {
            if ((sprite.reelX === symbol.reelX) && (sprite.reelY === symbol.reelY)) {
                if (sprite.wild) {
                    isWild = sprite;
                } else {
                    this.layer.wild.removeChild(sprite);
                }
            }
        }
        if (isWild) {
            isWild.visible = true;
            isWild.alpha = 1;
        } else {
            let wild = new PIXI.Sprite(PIXI.Texture.from("symbol_crystal_wild.png"));
            wild.anchor.set(0.5,0.5);
            wild.position.set(symbol.x, symbol.y);
            wild.wild = true;
            wild.reelX = symbol.reelX;
            wild.reelY = symbol.reelY;
            this.layer.wild.addChild(wild);
        }
    }

    drawWildSymbols() {
        for (let symbol of this.resSymbols) {
            if (symbol.name === 'symbol_crystal_wild')
                if (!this.winSymbols[symbol.reelX][symbol.reelY]) {
                    symbol.alpha = 1;
                }
        }
    }

    hideSymbol(symbol) {
        this.winSymbols[symbol.reelX][symbol.reelY].visible = false;
    }

    showSymbol(symbol) {
        this.winSymbols[symbol.reelX][symbol.reelY].visible = true;
    }
}
export default SymbolAnimations;
